<div class="custom-snackbar" [ngClass]="'snackbar-' + (data.type || 'info')">
  @if (data.type) {
    <div class="snackbar-icon">
      <mat-icon>{{ getIconForType(data.type) }}</mat-icon>
    </div>
  }
  <div class="snackbar-content">
    @if (data.title) {
      <div class="snackbar-title">{{ data.title }}</div>
    }
    <div class="snackbar-message">{{ data.message }}</div>
    @if (data.template) {
      <ng-container [ngTemplateOutlet]="data.template"></ng-container>
    }
  </div>
  <button
    mat-icon-button
    (click)="snackBarRef.dismiss()"
    class="close-button"
    aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>